import React, { useEffect, useState } from "react";
import { api, imgUrl } from "../lib/api";
import { Instagram, ArrowUpRight } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const InstagramWall = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { settings } = useSettings();

  useEffect(() => {
    api
      .get("/insta-posts")
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || posts.length === 0) return null;

  const handle = settings.contact_instagram || "jeweloncanvas";

  return (
    <section
      className="px-6 md:px-12 lg:px-20 py-20 md:py-28 border-t border-[#D8D3CC]"
      data-testid="instagram-wall"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
        <div>
          <div className="label-eyebrow mb-3">On Instagram</div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1F1B]">
            @{handle}
          </h2>
        </div>
        <a
          href={`https://instagram.com/${handle}`}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 nav-link"
          data-testid="instagram-wall-follow"
        >
          <Instagram size={14} strokeWidth={1.6} /> Follow the studio{" "}
          <ArrowUpRight size={14} />
        </a>
      </div>

      <div
        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3"
        data-testid="instagram-wall-grid"
      >
        {posts.slice(0, 6).map((p) => (
          <a
            key={p.id}
            href={p.post_url}
            target="_blank"
            rel="noreferrer"
            className="relative aspect-square overflow-hidden bg-[#EFECE5] group"
            data-testid={`instagram-wall-item-${p.id}`}
            title={p.caption || "View on Instagram"}
          >
            <img
              src={imgUrl(p.image_url)}
              alt={p.caption || "Instagram post"}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#1A1F1B]/0 group-hover:bg-[#1A1F1B]/40 transition-colors flex items-center justify-center">
              <Instagram
                size={22}
                strokeWidth={1.4}
                className="text-[#F7F6F2] opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default InstagramWall;
